import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TemplateDetailPage } from '@/features/editor/templates/template-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Un gabarit : ses versions (la version choisie vit dans l'URL, `?version=`), sa description, ses
 * paramètres, et son rendu ouvert comme nouveau graphe dans l'éditeur.
 */
export const Route = createFileRoute('/$tenant/editor/templates/$templateName')({
  validateSearch: (search: Record<string, unknown>): { version?: string } =>
    typeof search['version'] === 'string' && /^[0-9A-Za-z.+-]{1,32}$/u.test(search['version'])
      ? { version: search['version'] }
      : {},
  component: TemplateRoute,
});

function TemplateRoute() {
  const { tenant, templateName } = Route.useParams();
  const { version } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="editor"
      crumbs={[
        { label: t('nav.items.editor') },
        { label: t('gallery.title') },
        { label: templateName, mono: true },
      ]}
    >
      <TemplateDetailPage
        tenantId={tenant}
        name={templateName}
        version={version}
        onVersionChange={(next) => void navigate({ search: { version: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
